import { Card, CardBody, CardTitle, CardSubtitle, Table } from "reactstrap";
import PropTypes from 'prop-types';

const AmenitiesTable = ({ title, tableData }) => {
  return (
    <div>
      <Card style={{ boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.05)', marginBottom: '30px' }}>
        <CardBody>
          <CardTitle tag="h5">{title}</CardTitle>
          <CardSubtitle className="mb-2 text-muted" tag="h6">
            Reservaciones
          </CardSubtitle>

          <Table className="no-wrap mt-3 align-middle" responsive borderless size="sm">
            <thead>
              <tr>
                <th>Amenidad</th>
                <th>Fecha</th>
                <th>Hora</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              {tableData.length === 0 ? (
                <div className="text-center text-gray-500">No hay reservaciones.</div>
              ) : (
                tableData.map((tdata, index) => {
                  let statusIndicator;
                  let statusText;
                  if (tdata.status === 0) {
                    statusIndicator = <span className="p-2 bg-warning rounded-circle d-inline-block ms-3"></span>;
                    statusText = 'Pendiente';
                  } else {
                    statusIndicator = <span className="p-2 bg-success rounded-circle d-inline-block ms-3"></span>;
                    statusText = 'Agendado';
                  }
                  // Use id if present and unique, else fallback to index
                  const key = tdata.id ? `row-${tdata.id}` : `row-${index}`;
                  return (
                    <tr key={key} className="border-top">
                      <td>
                        <div className="d-flex align-items-center p-0">
                          <div className="ms-3">
                            <span className="text-muted">{tdata.type}</span>
                          </div>
                        </div>
                      </td>
                      <td>{tdata.createdDate}</td>
                      <td>{tdata.hour}</td>
                      <td>
                          {statusIndicator} <span className="text-muted">{statusText}</span>
                      </td>
                    </tr>
                  );
                }

                ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

AmenitiesTable.propTypes = {
  title: PropTypes.string.isRequired,
  tableData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.string.isRequired,
    status: PropTypes.number,
    createdDate: PropTypes.string,
    hour: PropTypes.string.isRequired
  })).isRequired
};

export default AmenitiesTable;
